import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  withCredentials: false,
});

// Injecter le token Bearer si présent
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ynd_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Rediriger vers /login si token expiré
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ynd_token');
      localStorage.removeItem('ynd_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ── Auth ──────────────────────────────────────────────────────────────
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
};

// ── Mentors ───────────────────────────────────────────────────────────
export const mentorsAPI = {
  list: (params) => api.get('/mentors', { params }),
  show: (id) => api.get(`/mentors/${id}`),
  contact: (id, data) => api.post(`/mentors/${id}/contact`, data),
  mySessions: () => api.get('/my/sessions'),
};

// ── Recommandations ───────────────────────────────────────────────────
export const recommendationsAPI = {
  index: (params) => api.get('/recommendations', { params }),
};

// ── Masterclasses ─────────────────────────────────────────────────────
export const masterclassesAPI = {
  list: (params) => api.get('/masterclasses', { params }),
  show: (id) => api.get(`/masterclasses/${id}`),
  enroll: (id) => api.post(`/masterclasses/${id}/enroll`),
  myEnrollments: () => api.get('/my/enrollments'),
};

// ── Opportunités ──────────────────────────────────────────────────────
export const opportunitiesAPI = {
  list: (params) => api.get('/opportunities', { params }),
  show: (id) => api.get(`/opportunities/${id}`),
  apply: (id, data) => api.post(`/opportunities/${id}/apply`, data),
};

// ── Paiements ─────────────────────────────────────────────────────────
export const paymentsAPI = {
  initiate: (data) => api.post('/payments/initiate', data),
  mine: () => api.get('/payments/mine'),
  activeSubscription: () => api.get('/payments/subscription'),
};

// ── Profil ────────────────────────────────────────────────────────────
export const profileAPI = {
  show: () => api.get('/profile'),
  update: (data) => api.put('/profile', data),
  changePassword: (data) => api.put('/profile/password', data),
};

// ── Diaspora Contribution Index (DCI) ─────────────────────────────────
export const dciAPI = {
  global: () => api.get('/diaspora-contribution-index'),
  adminList: () => api.get('/admin/diaspora-contribution-index'),
};

// ── Contribution Cycle Engine (CCE) ───────────────────────────────────
export const cceAPI = {
  list: () => api.get('/contribution-cycles'),
};

// ── Statistiques publiques (vitrine) ──────────────────────────────────
export const statsAPI = {
  platform: () => api.get('/platform-stats'),
};

export default api;
